"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LEGAL_NOTICE_HOSTER_NAME = exports.LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST = void 0;
exports.getDeploymentLineLegalNotice = getDeploymentLineLegalNotice;
exports.LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST = "sur demande";
exports.LEGAL_NOTICE_HOSTER_NAME = "4NK";
const DEPLOYMENT_LINE_LEGAL_NOTICE_LECOFFREIO = {
    effectiveFromLabel: "9 septembre 2026",
    lcenIntro: "Conformément à l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique (LCEN), voici les informations relatives à l'éditeur, au propriétaire et à l'hébergeur du site.",
    ownerName: "LeCoffre.io",
    ownerRegisteredOffice: "2 Mail Anne-Catherine, 35000 Rennes",
    ownerSiret: "927 474 361 00015",
    ownerVatIntra: "FR17 927 474 361",
    ownerRcs: "Rennes 927 474 361",
    publicationDirectorName: "Laurence Koenig",
    ownerContactEmail: "contact@lecoffre.io",
    editorName: "PLR Studio",
    editorResponsibleName: "Paul Rolland",
    editorLegalForm: "Entrepreneur individuel (EI)",
    editorAddress: "10 rue Edmond Guillout, 75015 Paris",
    editorSiret: "106 334 980 00013",
    editorVatNote: "Non applicable, art. 293 B du CGI",
    editorActivity: "Conception, design et édition du site lecoffre.io",
    editorWebsiteLabel: "plrstudio.fr",
    editorWebsiteHref: "https://plrstudio.fr",
    editorContactEmail: "contact@plrstudio.fr",
    hosterName: exports.LEGAL_NOTICE_HOSTER_NAME,
    hosterDetailsLabel: exports.LEGAL_NOTICE_HOSTER_DETAILS_ON_REQUEST,
    questionsLeadIn: "Pour toute question relative au site ou à ces mentions légales, vous pouvez nous écrire à",
};
function getDeploymentLineLegalNotice(_siteCode) {
    return DEPLOYMENT_LINE_LEGAL_NOTICE_LECOFFREIO;
}
